export const config = {
  frontendUrl: process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://mt-bringsl.netlify.app',
};
